/**
 * Example appState - vuex module
 */
import { MutationTree, ActionTree, GetterTree } from 'vuex';

import { IMoaState } from './@types';

/**
 * State
 */
const state: IMoaState = {
	moaScreen: 'splash',
	moaActiveSection: 'moa-introduction',
	moaActiveFrame: 'moa-frame-not-approved',
	moaInsideCell: false,
};

/**
 * Mutations
 */
const mutations: MutationTree<IMoaState> = {
	updateMoaScreen (stateObj: IMoaState, screen: string) {
		stateObj.moaScreen = screen;
	},
	updateMoaActiveSection (stateObj: IMoaState, section: string) {
		stateObj.moaActiveSection = section;
	},
	updateMoaActiveFrame (stateObj: IMoaState, frame: string) {
		stateObj.moaActiveFrame = frame;
	},
	updateMoaInsideCell (stateObj: IMoaState, value: boolean) {
		stateObj.moaInsideCell = value;
	},
};

/**
 * Getters
 */
const getters: GetterTree<IMoaState, any> = {
	get_moaScreen (stateObj: IMoaState): string {
		return stateObj.moaScreen;
	},
	get_moaActiveSection (stateObj: IMoaState): string {
		return stateObj.moaActiveSection;
	},
	get_moaActiveFrame (stateObj: IMoaState): string {
		return stateObj.moaActiveFrame;
	},
	get_moaInsideCell (stateObj: IMoaState): boolean {
		return stateObj.moaInsideCell;
	},
};

/**
 * Actions
 */
const actions: ActionTree<IMoaState, any> = {
	axn_moaUpdateScreen (context: any, screen: string) {
		context.commit('updateMoaScreen', screen);
	},
	axn_updateMoaActiveSection (context: any, section: string) {
		context.commit('updateMoaActiveSection', section);
	},
	axn_updateMoaActiveFrame (context: any, frame: string) {
		context.commit('updateMoaActiveFrame', frame);
	},
	axn_updateMoaInsideCell (context: any, value: boolean) {
		context.commit('updateMoaInsideCell', value);
	},
};

/**
 * Export
 */
export default {
	namespace: true,
	state,
	mutations,
	getters,
	actions,
};
